export default {
  notfound: {
    title: 'Questa pagina non è ancora stata generata',
    hint: 'Raccontami di più su questa pagina, così posso generarla',
  },
};